import Component from 'flarum/common/Component';
import { sectionIcons } from '../icons';

/**
 * Section icon. An icon set for the tag in Admin → Tags (Font Awesome class) wins; otherwise the
 * portal's own line icon for the section's slug; otherwise nothing.
 */
export default class SectionIcon extends Component {
  view() {
    const tag = this.attrs.model;
    const adminIcon = tag.icon();
    if (adminIcon) return m("i", {
      className: 'TpIcon TpIcon--fa ' + adminIcon,
      "aria-hidden": "true"
    });
    const inner = sectionIcons[tag.slug()];
    if (!inner) return null;
    return m("svg", {
      className: "TpIcon",
      viewBox: "0 0 26 26",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": ".9",
      "aria-hidden": "true"
    }, m.trust(inner));
  }
}
flarum.reg.add('tarotportal-theme', 'forum/components/SectionIcon', SectionIcon);